<template>
<div>
  <b-container style="width: 32rem; margin:0; padding:0">
    <b-row>
      <b-col cols="6">Date<br />
        <v-date-picker v-model="meetingDate" :masks="{input:'WWWW  DD-MMM-YYYY'}"  :input-props='{
    id: "meetingDate",}'/>
      </b-col>
      <b-col cols="3">
        Start<br>
        <multiselect id="time" ref="time" v-model="meetingTime" :options="startTimes" :show-labels="false" :searchable="false"  @open="selectTime('time')">
        </multiselect>

      </b-col>
      <b-col cols="3">
        End
        <multiselect ref="endTime" v-model="meetingEndTime" :options="startTimes" :show-labels="false" :searchable="false"  @open="selectTime('endTime')">
        </multiselect>
    </b-col>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6"></b-col>
      <b-col cols="6" style="color:#808080; line-height: 2rem">
        <span style="margin-left:0.2rem">Duration: {{ dispDuration }}</span><br />
      </b-col></b-row>
  </b-container>
</div>
</template>
<script>
export default {
  // props: ['date','time','duration'],
  props: ['meeting'],
  data () {
    return {
      meetingDate:'',
      meetingDuration:'' ,
      meetingTime: '',
      meetingEndTime: '',
      calAttributes: [{
           key: 'today',
           dot: true,
           dates: new Date(),
        }],
    }
  },
  watch: {
    meeting () {
      this.updateMeeting()
    },
    meetingDate (){
      this.$emit('dateChanged',this.meetingDate)
    },
    meetingTime (){
      // Set End time based on duration
      this.meetingEndTime = this.$moment(this.meetingTime,'HH:mm').add(parseInt(this.meetingDuration), 'minutes').format('HH:mm')
      this.$emit('timeChanged', this.meetingTime)
    },
    meetingDuration () {
      this.$emit('durationChanged', this.meetingDuration)
    },
  meetingEndTime () {
    // If End time <= start time then reset start time based on duration
    if (this.$moment(this.meetingEndTime,'HH:mm') <= this.$moment(this.meetingTime,'HH:mm')) {
      this.meetingTime = this.$moment(this.meetingEndTime,'HH:mm').subtract(parseInt(this.meetingDuration),'minutes').format('HH:mm')
    } else {
      // Set duration based on start and end time
      this.meetingDuration = this.$moment(this.meetingEndTime,'HH:mm').diff(this.$moment(this.meetingTime,'HH:mm'),'minutes')
    }
    }
  },
  computed: {
    dispDuration () {
       var dur = this.$moment()
       dur.seconds(0)
       dur.hours(0)
       dur.minute(parseInt(this.meetingDuration))
       return dur.format('HH:mm')
    },
    startTimes () {
      var timeSlots= []
      var start = this.$moment()
      var end = this.$moment()
      start.set({hour:0,minute:0,second:0,millisecond:0})
      end.set({hour:0,minute:0,second:0,millisecond:0})
      end.add(24,'hours')
      timeSlots [0] = start.format('HH:mm')
      start.add('15', 'minutes')
      timeSlots [1] = start.format('HH:mm')
      var i=0
      while (start.isBefore(end)) {
        start.add('15', 'minutes')
        timeSlots[i] = start.format('HH:mm')
        i++
      }
      return timeSlots
    }
  },
  methods: {
    updateMeeting () {
      this.meetingDate = new Date(this.meeting.date)
      this.meetingTime = this.meeting.time
      this.meetingDuration = this.meeting.duration
    },
    selectTime (element) {
      const select = this.$refs[element]
      let position = select.filteredOptions.indexOf(select.value)
      select.pointerSet(position)
      this.$nextTick(() => {
        select.$refs.list.scrollTop = select.pointerPosition-50
      })
    },
  },
  mounted: function (){
    this.updateMeeting()
    // this.meetingEndTime = this.$moment(this.meetingTime,'HH:mm').add(parseInt(this.meetingDuration), 'minutes').format('HH:mm')
  }
}
</script>
<style scoped>
</style>
